import React,{useState} from 'react';
import styled from 'styled-components';
import {CONSTS}  from './_constants';
import { BASE_URL } from '../../inc/constants';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/languages/fa';
// import 'froala-editor/js/plugins.pkgd.min.js';
///<reference path= "./../../inc/froala.d.ts" />
import FroalaEditorComponent from 'react-froala-wysiwyg';

const FormEditorComponent = (props:any) => {
    const [isFocus, setIsFocus] = useState(false)     
    const FroalaConfig = {
        imageUploadURL: `${BASE_URL}/medias/`,
        imageUploadMethod: 'POST',
        imageUploadRemoteUrls: true,
        imageUploadParam: 'file',
        language: 'fa',
        requestHeaders: {
            Authorization: `Token ${props.token}`
        }
    }
    return (
    <div className={`${props.className} ${isFocus ? "_isFocus": ""}`}>
        {/* <textarea {...props} className="" onBlur={()=>setIsFocus(false)} onFocus={()=>setIsFocus(true)}/> */}
        <FroalaEditorComponent config={FroalaConfig} model={props.value} onModelChange={props.onChange} tag='textarea' {...props}/>
        <label spellCheck={false} htmlFor={"id_" + props.field.id}>{props.field.label}{props.required && '*'}</label>
    </div>
    )
}

const FormEditor = styled(FormEditorComponent)`
    &._isFocus {
        border: 1px solid ${CONSTS.colors.primary};
        background: rgba(99,87,255,0.05);
    }    
    border: 1px solid #DDE2EB;
    background: rgba(221,226,235,0.05);
    border-radius: 8px;
    position: relative;
    min-height: 43px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: stretch;
    overflow: hidden;
    transition: ease border-color .25s;
    label {
        display: inline-block;
        font-family: ${CONSTS.fonts.primary.light};
        font-size: 16px;
        color: ${CONSTS.colors.primaryDark};
        padding-right: 12px;
        padding-left: 12px;
        min-height: 43px;
        border-bottom: 1px solid #DDE2EB;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        transition: ease border-color .25s,ease color .25s;
    }
    .fr-box{
        .fr-toolbar.fr-top, .fr-wrapper, .second-toolbar {
            border: none !important;
        }
        &.fr-basic.fr-rtl .fr-element{
            font-family: ${CONSTS.fonts.primary.regular};
            color: ${CONSTS.colors.primaryDark};
        }
        border: 0;
        background: transparent;
        &:focus{
            outline: none;
            & ~ label {
                border-color: ${CONSTS.colors.primary};
                color: ${CONSTS.colors.primary};
            }
        }
        &::placeholder{
            color:#999;
        }
    }
`;

export default FormEditor;